<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มวันหยุดใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ holidayItemInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="holidayItemInit.holiday_type">
              {{ holidayItemInit.holiday_type.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <v-dialog
          ref="dialogDateHoliday"
          v-model="modalDateHoliday"
          :return-value.sync="holidayItem.holiday_date"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2">
                วันที่
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                :value="holidayDateFormatted"
                :rules="[(v) => !!v || 'โปรดระบุวันที่']"
                append-icon="mdi-calendar"
                @click:append="modalDateHoliday = true"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="holidayDateClear('holiday_date')"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="holidayItem.holiday_date"
            scrollable
            locale="th-TH"
            :year-format="yearFormatted"
            :header-date-format="headerDateFormatted"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalDateHoliday = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogDateHoliday.save(holidayItem.holiday_date)"
              >ตกลง
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <label class="body-2">
          คำอธิบาย (ไทย)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          v-model="holidayItem.title_th"
          :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          v-model="holidayItem.title_en"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ประเภทวันหยุด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          v-model="holidayItem.holiday_type_uuid"
          :rules="[(v) => !!v || 'โปรดระบุประเภทวันหยุด']"
          :items="holidayTypes"
          item-text="title_th"
          item-value="holiday_type_uuid"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isHolidayDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::holiday:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::holiday:create')"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::holiday:update')"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    holidayItem: {
      type: Object,
    },
    holidayItemInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      modalDateHoliday: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    holidayDateFormatted() {
      return this.holidayItem.holiday_date
        ? moment(this.holidayItem.holiday_date).format('DD/MM/YYYY')
        : ''
    },
    isHolidayDataChange() {
      if (
        this.holidayItem?.holiday_type_uuid !==
          this.holidayItemInit?.holiday_type_uuid ||
        this.holidayItem.title_th !== this.holidayItemInit.title_th ||
        this.holidayItem.title_en !== this.holidayItemInit.title_en ||
        this.holidayItem.holiday_date !== this.holidayItemInit.holiday_date
      ) {
        this.$emit('isHolidayDataChange', true)
        return true
      }
      this.$emit('isHolidayDataChange', false)
      return false
    },
    holidayTypes() {
      return this.$store.state.holiday.holidayTypes
    },
  },
  methods: {
    ...mapActions({
      addHoliday: 'holiday/addHoliday',
      editHoliday: 'holiday/editHoliday',
      deleteHoliday: 'holiday/deleteHoliday',
    }),
    holidayDateClear(field) {
      this.holidayItem[field] = undefined
    },
    yearFormatted(year) {
      return `ค.ศ. ${year}`
    },
    headerDateFormatted(date) {
      // use momentjs
      return moment(date).locale('th').format('MMMM YYYY')

      // not use library
      // const monthsOfYear = [
      //   'มกราคม',
      //   'กุมภาพันธ์',
      //   'มีนาคม',
      //   'เมษายน',
      //   'พฤษภาคม',
      //   'มิถุนายน',
      //   'กรกฎาคม',
      //   'สิงหาคม',
      //   'กันยายน',
      //   'ตุลาคม',
      //   'พฤศจิกายน',
      //   'ธันวาคม'
      // ]
      // let i = new Date(date).getMonth(date)
      // return `${monthsOfYear[i]} ${date.split('-')[0]}`
    },
    checkEmpty(value, field) {
      if (value) {
        this.holidayItem[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบวันหยุด',
        value: `${moment(this.holidayItem.holiday_date).format(
          'DD/MM/YYYY'
        )} - ${this.holidayItem.title_th}`,
        item: this.holidayItem,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ holiday_uuid }) {
      const { company_uuid } = this.$store.state.authentication.company

      this.confirmDialogDeleteLoading = true

      const payload = {
        company_uuid,
        holiday_uuid,
      }

      this.deleteHoliday(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const payload = {
          company_uuid,
          body: {
            holiday_date: moment(this.holidayItem.holiday_date).format(
              'YYYY-MM-DD'
            ),
            holiday_type_uuid: this.holidayItem.holiday_type_uuid,
            title_th: this.holidayItem.title_th,
            title_en: this.holidayItem.title_en || null,
          },
        }

        this.addHoliday(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.holidayItem.holiday_date = undefined

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const payload = {
          company_uuid,
          holiday_uuid: this.holidayItem.holiday_uuid,
          body: {
            holiday_date: moment(this.holidayItem.holiday_date).format(
              'YYYY-MM-DD'
            ),
            holiday_type_uuid: this.holidayItem.holiday_type_uuid,
            title_th: this.holidayItem.title_th,
            title_en: this.holidayItem.title_en || null,
          },
        }

        this.editHoliday(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isHolidayDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.holidayItem.holiday_date = undefined

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.holidayItem.holiday_date = undefined

        this.$refs.form.resetValidation()
        // this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
